/* Copyright (c) 2020-2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { Button, FlexContainer, SVGIcon, Table, theme } from "@nordcloud/gnui";

export const MultiSelectSubmitContainer = styled.div`
  display: flex;
  justify-content: left;
  align-items: flex-start;
  padding: ${theme.spacing.spacing03};
  background-color: ${theme.color.background.ui01};
  position: sticky;
  gap: ${theme.spacing.spacing04};
  flex: 1;
  bottom: 0;
`;

export const StatusColumn = styled(Table.td)`
  text-align: center;
  vertical-align: middle;
  user-select: none;
  svg {
    padding-top: ${theme.spacing.spacing01};
  }
`;

export const Wrap = styled.div`
  margin-bottom: ${theme.spacing.spacing03};
`;

export const SwitchWrap = styled.div`
  pointer-events: none;
`;

export const ExpandIcon = styled(SVGIcon)<{
  isExpanded: boolean;
  noMargin?: boolean;
}>`
  display: flex;
  margin: ${({ noMargin }) =>
    noMargin ? theme.spacing.spacing00 : theme.spacing.spacing03};
  cursor: pointer;
  transition: transform 0.1s linear;
  transform: ${({ isExpanded }) =>
    isExpanded ? "rotate(0deg)" : "rotate(-90deg)"};
  flex-shrink: 0;
`;

export const FilterItemWrapper = styled(FlexContainer)<{
  isFilterSelected: boolean;
}>`
  height: ${theme.lineHeight};
  padding: ${theme.spacing.spacing03} 0;
  background-color: ${({ isFilterSelected }) =>
    isFilterSelected ? theme.color.background.ui04 : undefined};
`;

export const ClearButton = styled(Button)`
  background: none;
  color: ${theme.color.text.info};
  &:hover {
    background: none;
    text-decoration: underline;
    color: ${theme.color.text.info};
  }
`;
